import { render, staticRenderFns } from "./fittingsInit.vue?vue&type=template&id=27570e35&scoped=true"
import script from "./fittingsInit.vue?vue&type=script&lang=js"
export * from "./fittingsInit.vue?vue&type=script&lang=js"
import style0 from "./fittingsInit.vue?vue&type=style&index=0&id=27570e35&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27570e35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27570e35')) {
      api.createRecord('27570e35', component.options)
    } else {
      api.reload('27570e35', component.options)
    }
    module.hot.accept("./fittingsInit.vue?vue&type=template&id=27570e35&scoped=true", function () {
      api.rerender('27570e35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemInit/fittingsInit/fittingsInit.vue"
export default component.exports